import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import api from "../../api";
import {
  handleDownloadReceipt,
  handleShareReceipt,
} from "../../utils/receiptUtils";
import "./deposit-history.css";

import logo from "./img/logo.svg";
import iconTransaction from "./img/time.svg";
import iconDeposit from "./img/deposit.svg";
import iconLogout from "./img/logout.svg";
import download from "./img/download.svg";
import share from "./img/share.svg";
import close from "./img/close.svg";
import copyDone from "./img/copy-done.svg";
import copyIcon from "./img/copy-icon.svg";
import searchIcon from "./img/search.svg";
import periodIcon from "./img/period.svg";
import arrowIcon from "./img/arrow.svg";

const DepositHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [modalType, setModalType] = useState(null);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [isPeriodSelectVisible, setIsPeriodSelectVisible] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copiedInvoiceId, setCopiedInvoiceId] = useState(null);
  const [copiedAddress, setCopiedAddress] = useState(null);
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    user_name: "",
    email: "",
  });

  const handlePeriodClick = () => {
    setIsPeriodSelectVisible(!isPeriodSelectVisible);
  };

  // let transactions = [
  //   {
  //     transaction_id: 1,
  //     address: "TRdvRVNKgSPBWgsdfsdgsdgsfhawerwrqwerBX69Xze1obyC",
  //     email: "user1@example.com ",
  //     amount: 100.0,
  //     currency: "USD",
  //     payment_method: "credit_card",
  //     status: "completed",
  //     invoice_id: "INV-123456",
  //     cashier_id: "CASH-001",
  //     note: "Payment for order #123",
  //     created_at: "2023-10-05T14:30:00Z",
  //   },
  //   {
  //     transaction_id: 2,
  //     address: "TRdvRVNKgSPBWBX6dsgsdsgfsdfsdfsdgsdgsd9Xze1obyC",
  //     email: "user2@example.com ",
  //     amount: 50.5,
  //     currency: "EUR",
  //     payment_method: "paypal",
  //     status: "pending",
  //     invoice_id: "INV-123457",
  //     cashier_id: "CASH-002",
  //     note: "",
  //     created_at: "2023-10-05T15:45:00Z",
  //   },
  // ];

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const response = await api.get("/api/user", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = response.data;
        setUserData({
          user_name: data.user_name || "",
          email: data.email || "",
        });
      } catch (err) {
        if (err.response?.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
        } else if (err.response?.data?.error) {
          setError(err.response.data.error.message);
        } else {
          setError("An unexpected error occurred.");
        }
      }
    };

    const token = localStorage.getItem("token");
    if (token) {
      fetchUserData();
    }
  }, [navigate]);

  const fetchTransactions = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const countResponse = await api.get("/api/transactionsForAdmin", {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          limit: 1000,
          offset: 0,
          filter: searchQuery,
          dateFrom: startDate || "",
          dateTo: endDate || "",
        },
      });

      const totalCount = countResponse.data.length;
      console.log(totalCount);
      setTotalPages(Math.ceil(totalCount / limit));

      const response = await api.get("/api/transactionsForAdmin", {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          limit,
          offset: (page - 1),
          filter: searchQuery,
          dateFrom: startDate ? startDate : "",
          dateTo: endDate ? endDate : "",
        },
      });

      setTransactions(response.data);
    } catch (err) {
      setError(
        err.response?.data?.error?.message || "Failed to fetch transactions"
      );
    }
  }, [limit, page, searchQuery, startDate, endDate]);

  // Обработки изменения страницы
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  useEffect(() => {
    if (transactions.length === 0 && page === 1) {
      setError("No transactions found");
    } else {
      setError("");
    }
  }, [transactions, page]);

  useEffect(() => {
    fetchTransactions();
  }, [fetchTransactions]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");

    navigate("/");
  };

  const openModal = (type, transaction) => {
    setModalType(type);
    setSelectedTransaction(transaction);
    setIsModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setModalType(null);
    setSelectedTransaction(null);
    setIsModalOpen(false);
    document.body.style.overflow = "";
  };

  const handleCopy = (invoiceId) => {
    setCopiedInvoiceId(invoiceId);
    setTimeout(() => {
      setCopiedInvoiceId(null);
    }, 3000);
  };

  const handleCopyAddress = (sendingAddress) => {
    setCopiedAddress(sendingAddress);
    setTimeout(() => {
      setCopiedAddress(null);
    }, 3000);
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const capitalizeFirstLetter = (text) => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  const handleDownloadReceiptWrapper = () => {
    if (!selectedTransaction) return;

    handleDownloadReceipt(
      () => Promise.resolve(selectedTransaction),
      selectedTransaction.transaction_id
    ).catch((err) => setError(err.message));
  };

  const handleShareReceiptWrapper = () => {
    if (!selectedTransaction) return;

    handleShareReceipt(selectedTransaction).catch((err) =>
      setError(err.message)
    );
  };

  const AddressInput = (sendingAddress) => {
    const maxLength = 30;

    const truncatedAddress =
      sendingAddress && sendingAddress.length > maxLength
        ? `${sendingAddress.slice(0, maxLength / 2)}...${sendingAddress.slice(
            -maxLength / 2
          )}`
        : sendingAddress;

    return truncatedAddress;
  };

  return (
    <div className="historyContainer">
      <div className="historySidebar">
        <div>
          <div className="historyLogoWrap">
            <img className="historyLogo" src={logo} alt="logo" />
          </div>
          <div>
            <div className="historyTab disabled">
              <img src={iconTransaction} alt="icon" />
              Transactions history
              <span>2</span>
            </div>
            <div className="historyTab active">
              <img src={iconDeposit} alt="icon" />
              Deposit history
            </div>
          </div>
        </div>
        <div className="sidebarBottom">
          <div className="sidebarBottomName">{userData.user_name}</div>
          <div className="sidebarBottomEmail">{userData.email}</div>
          <div className="logoutBtn" onClick={handleLogout}>
            <img src={iconLogout} alt="icon" />
            Log out
          </div>
        </div>
      </div>
      <div className="historyContent">
        <div className="historyTop">
          <img className="searchIcon" src={searchIcon} alt="search" />
          <input
            className="historyTopInput"
            placeholder="Search by username, email..."
            value={searchQuery}
            onChange={handleSearch}
          />
          <div className="historyPeriodWrap">
            <div className="historyPeriod" onClick={handlePeriodClick}>
              <img className="periodIcon" src={periodIcon} alt="period" />
              Choose period
              <img className="periodIconArrow" src={arrowIcon} alt="arrow" />
            </div>
            {isPeriodSelectVisible && (
              <div className="periodDateWrap">
                <div>Start:</div>
                <input
                  type="date"
                  id="start"
                  name="startDate"
                  value={startDate}
                  onChange={(e) => {
                    setStartDate(e.target.value);
                    setPage(1);
                    fetchTransactions();
                  }}
                />
                <div>End:</div>
                <input
                  type="date"
                  id="end"
                  name="endDate"
                  value={endDate}
                  onChange={(e) => {
                    setEndDate(e.target.value);
                    setPage(1);
                    fetchTransactions();
                    handlePeriodClick();
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="historyTable historyTableContainer">
          {error && page === 1 && <div className="error">{error}</div>}
          {!error && transactions.length === 0 && page > 1 && (
            <div className="error">Nothing was found</div>
          )}
          {!error && (
            <>
              <div className="historyTableWrap">
                <table className="historyTable">
                  <thead>
                    <tr>
                      <th scope="col">Invoice ID</th>
                      <th scope="col">Email</th>
                      <th scope="col">Username</th>
                      <th scope="col">Payment Address</th>
                      <th scope="col">Payment Status</th>
                      <th scope="col">Payment Method</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Note</th>
                      <th scope="col">Receipt</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.map((transaction) => (
                      <tr key={transaction.transaction_id}>
                        <th scope="row">
                          <span>{transaction.invoice_id?.slice(0, 5)}</span>
                          <CopyToClipboard
                            text={transaction.invoice_id}
                            onCopy={() => handleCopy(transaction.invoice_id)}
                          >
                            <img
                              className={`addressCopy addressCopyHistory ${
                                copiedInvoiceId !== transaction.invoice_id &&
                                "addressCopyWrap"
                              }`}
                              src={
                                copiedInvoiceId === transaction.invoice_id
                                  ? copyDone
                                  : copyIcon
                              }
                              alt="copy"
                            />
                          </CopyToClipboard>
                        </th>
                        <td className="td-250">{transaction.email}</td>
                        <td className="td-pr">{userData.user_name}</td>
                        <td className="td-250 td-relative">
                          <span className="td-span">
                            {AddressInput(transaction.sending_address)}
                          </span>
                          <CopyToClipboard
                            text={transaction.sending_address}
                            onCopy={() =>
                              handleCopyAddress(transaction.sending_address)
                            }
                          >
                            <img
                              className={`addressCopy addressCopyHistory ${
                                copiedAddress !== transaction.sending_address &&
                                "addressCopyWrap"
                              }`}
                              src={
                                copiedAddress === transaction.sending_address
                                  ? copyDone
                                  : copyIcon
                              }
                              alt="copy"
                            />
                          </CopyToClipboard>
                        </td>
                        <td
                          className={`td-pr ${
                            transaction.status === "COMPLETED"
                              ? "green"
                              : transaction.status === "FAILED"
                              ? "red"
                              : ""
                          }`}
                        >
                          {capitalizeFirstLetter(transaction.status)}
                        </td>
                        <td className="tdMethod td-pr">
                          {transaction.payment_method}
                        </td>
                        <td className="tdMethod td-pr">
                          ${transaction.amount}
                        </td>
                        <td
                          className="tdMethod td-pr td-violet"
                          onClick={() => openModal("note", transaction)}
                        >
                          View
                        </td>
                        <td
                          className="tdMethod td-pr td-violet"
                          onClick={() => openModal("receipt", transaction)}
                        >
                          View
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {totalPages > 1 && (
                <div className="pagination">
                  <button
                    className="pagination-arrow"
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                  >
                    <svg
                      width="9"
                      height="14"
                      viewBox="0 0 9 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 1L2 7L8 13"
                        stroke="#0A0A0B"
                        stroke-width="1.5"
                      />
                    </svg>
                  </button>

                  {[...Array(totalPages).keys()].map((num) => (
                    <button
                      key={num + 1}
                      onClick={() => handlePageChange(num + 1)}
                      className={page === num + 1 ? "active" : ""}
                    >
                      {num + 1}
                    </button>
                  ))}

                  <button
                    className="pagination-arrow"
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === totalPages}
                  >
                    <svg
                      width="9"
                      height="14"
                      viewBox="0 0 9 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1L7 7L1 13"
                        stroke="#0A0A0B"
                        stroke-width="1.5"
                      />
                    </svg>
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {isModalOpen && modalType && selectedTransaction && (
        <div className="modalNoteWrap">
          <div className="modalNote">
            <img
              className="modalClose"
              onClick={() => closeModal()}
              src={close}
              alt="close"
            />
            {modalType === "receipt" ? (
              <>
                <div className="title titleModal">Receipt</div>
                <div className="borderWrap">
                  <div className="table">
                    <div className="tableRow">
                      <div>Invoice ID:</div>
                      <div>{selectedTransaction.invoice_id?.slice(0, 5)}</div>
                    </div>
                    <div className="tableRow">
                      <div>Cashier ID:</div>
                      <div>{selectedTransaction.cashier_id}</div>
                    </div>
                    <div className="tableRow">
                      <div>Date/Time:</div>
                      <div>{selectedTransaction.created_at}</div>
                    </div>
                    <div className="tableRow">
                      <div>Payment Method:</div>
                      <div>{selectedTransaction.payment_method}</div>
                    </div>
                    <div className="tableRow">
                      <div>Amount:</div>
                      <div>${selectedTransaction.amount}</div>
                    </div>
                  </div>
                  <div className="noteBg">
                    Please send this receipt to your cashier, or let them know
                    you have completed the payment.
                  </div>
                  <div className="complitedText">
                    DO NOT RESEND PAYMENT TO THIS BITCOIN ADDRESS AGAIN, WE ARE
                    NOT RESPONSIBLE FOR ANY LOSSES THAT GET SENT TO THE WRONG
                    BITCOIN ADDRESS
                  </div>
                  <div className="btnsWrap">
                    <button
                      className="btn"
                      onClick={handleDownloadReceiptWrapper}
                    >
                      <div>Download</div>
                      <img src={download} alt="download" />
                    </button>
                    <button className="btn" onClick={handleShareReceiptWrapper}>
                      <div>Share</div>
                      <img src={share} alt="share" />
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="title titleModal">Note</div>
                <div className="modalNoteBg">{selectedTransaction.note}</div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DepositHistory;
